/** The outbox (who was told what, on which channel, and how it went), retry and cancel (never the text of a message), and the club's
 * message templates. */
export const NOTIFICATIONS_MANAGE = "notifications.manage";
